import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

/**
 * Mapa Leaflet + CartoDB Positron com proporção 9:16 vertical.
 * Ícones locais para evitar bloqueio CSP.
 */
export default function MapaRota({ pontos, height = 480 }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef([]);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    // Fix default icon paths - usando arquivos locais
    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: '/images/marker-icon-2x.png',
      iconUrl: '/images/marker-icon.png',
      shadowUrl: '/images/marker-shadow.png',
    });
  }, []);

  useEffect(() => {
    let map;
    try {
      map = L.map(mapRef.current).setView([-17.8, -42.9], 11);
      
      L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: 19,
        subdomains: 'abcd',
      }).addTo(map);
      
      mapInstanceRef.current = map;
    } catch (err) {
      console.error('MapaRota init error:', err);
      setLoadError(err.message);
    }

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
      }
    };
  }, []);

  useEffect(() => {
    if (!mapInstanceRef.current || !Array.isArray(pontos)) return;

    markersRef.current.forEach(m => m.remove());
    markersRef.current = [];

    const latlngs = [];
    pontos.forEach((p) => {
      if (p.latitude && p.longitude) {
        const marker = L.marker([p.latitude, p.longitude])
          .addTo(mapInstanceRef.current)
          .bindPopup(`<strong>${p.numserv}</strong><br/>${p.tipo_serv}<br/>${p.dh_aciona}<br/>US: ${Number(p.us).toFixed(4)}`);
        markersRef.current.push(marker);
        latlngs.push([p.latitude, p.longitude]);
      }
    });

    if (latlngs.length > 0) {
      const bounds = L.latLngBounds(latlngs);
      mapInstanceRef.current.fitBounds(bounds, { padding: [40, 40] });
      setTimeout(() => {
        mapInstanceRef.current.invalidateSize();
      }, 100);
    }
  }, [pontos]);

  const width = (height * 9) / 16;

  if (loadError) {
    return (
      <div style={{
        height: `${height}px`,
        width: `${width}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-md)',
        color: 'var(--muted)',
        fontSize: 'var(--font-sm)',
      }}>
        Erro ao carregar mapa: {loadError}
      </div>
    );
  }

  return (
    <div 
      ref={mapRef} 
      style={{ 
        height: `${height}px`, 
        width: `${width}px`,
        borderRadius: 'var(--radius-md)',
        overflow: 'hidden',
        border: '1px solid var(--border)',
      }} 
    />
  );
}